import { AsoEbi } from "../../types/aso.ebi";
import { generateAPI } from "../api.generator";

export const getAllAsoEbi = generateAPI<
  {
    query: {
      weddingID: string;
    };
  },
  AsoEbi[]
>("get", "aso-ebi/all");
